<template>
    <div>
      <modal size="small">
          <div slot="header">Confirmation</div>
          <div slot="body">{{message}}</div>
          <div slot="footer" class="panel-footer" >
              <div class="row columns">
                <button class="large-4 light-grey-button" @click="$emit('closeMessage')">Annuler</button>
                <button class="large-4 large-offset-2 alert" @click="$emit('confirm')">Confirmer</button>
              </div>
          </div>
      </modal>
    </div>
</template>

<script>
import modal from './modal.vue'

export default {
  name: 'confirmModal',
  components: {
    modal
  },
  props: {
    'message': null
  },
  data () {
    return {
      showModal: false
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// confirm-modal.vue?57baf83f